// src/components/sections/HeroSection.js
import React from 'react';


function HeroSection({ title, subtext, backgroundImageUrl }) {
  return (
    <section
    
      id="home"
      className="relative flex items-center justify-center min-h-screen bg-cover bg-center text-slate-50
                 bg-slate-500/75 mix-blend-multiply" // Background color/opacity and blend mode
      // Use the background image URL passed as a prop and add a layer of opacity
      style={{
        backgroundImage: `url(${backgroundImageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Overlay */} 
      <div className="absolute inset-0 bg-sky-900 opacity-60"></div>
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black opacity-700"></div>
      {/* Background Image */}
    
      {/* Content Container */}
      <div className="relative z-10 container mx-auto px-6 text-center">
        {/* Title */}
        <h1 className="text-4xl md:text-5xl lg:text-5xl font-bold leading-tight mb-4 text-slate-100">
          {title}
        </h1>
        {/* Subtext */}
        <p className="text-lg md:text-xl lg:text-1xl text-gray-200 mb-8 max-w-3xl mx-auto text-gray-300">
          {subtext}
        </p>
      </div>
    </section>
  );
}

export default HeroSection;
